import { render, staticRenderFns } from "./Cryptocurrency.vue?vue&type=template&id=d61ca2fc&scoped=true&"
import script from "./Cryptocurrency.vue?vue&type=script&lang=js&"
export * from "./Cryptocurrency.vue?vue&type=script&lang=js&"
import style0 from "./Cryptocurrency.vue?vue&type=style&index=0&id=d61ca2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61ca2fc",
  null
  
)

export default component.exports